import React from "react"
import { withTranslation } from 'react-i18next';

class Footer extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <footer className={this.props.hide?'hide':''}>
                <span className="copyrights">{t('footer.copyright')}</span> <span className="copyrights-seperator "> | </span><a href="/terms.html" title={t('footer.links.terms')}>{t('footer.links.terms')}</a> | <a href="/privacy.html" title={t('footer.links.privacy')} >{t('footer.links.privacy')}</a> | <a href="/accessibility.html" title={t('footer.links.accessibility')}>{t('footer.links.accessibility')}</a> | <a href="/contact.html" title={t('footer.links.contact')}>{t('footer.links.contact')}</a>
            </footer>
        );
    }
}

export default withTranslation()(Footer)